import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import CampaignNameParams from './CampaignNameParams';

export type TagsInputValue = any[]

const mapStateToProps = (state, { t }) => {
  const campaignNameParams: TagsInputValue = state.trackerSettings.app.settings
    .attributes.campaign_name_params || [];
  const globalCampaignNameParams: TagsInputValue = (
    state.trackerSettings.global.settings
      .attributes.campaign_name_params || []
  )
    .map(
      element => ({
        value: element,
        disabled: true,
        tooltip: {
          content: t('apps.details.settings.globals.tooltip.content'),
        },
      }),
    );

  const globalAndAppTrackerSettings = [
    ...globalCampaignNameParams,
    ...campaignNameParams,
  ];

  return {
    globalAndAppTrackerSettings,
  };
};

export default withTranslation(['administration'])(connect(mapStateToProps, null)(CampaignNameParams));
